module.exports = __webpack_public_path__ + "static/media/动物平假名之歌.5c0ec0aa.flv";